import React, {useEffect, useContext, useState} from "react"
import {ReducerContext} from "./reducer"
import {GenericSelector} from './GenericSelector'
import DB from '../DAL/DB'
import {auth} from '../Auth'

const analytics = new DB.Analytics()

export default function Dropdowns ({ aggregatorDisabled = false }) {
  const {state, dispatch} = useContext(ReducerContext)
  const [fieldUsers, setFieldUsers] = useState([])
  const [reviewers, setReviewers] = useState([])
  const [installers, setInstallers] = useState([])

  // Fetch users for Field User, Reviewer, and Installer dropdowns
  useEffect(() => {
    async function fetchUsers() {
      const usersDB = new DB.Users()
      const orgId = auth.sunkaizenUser.organization.id
      
      // Fetch Field Users
      const {ok: okField, data: dataField} = await usersDB.get(null, {
        filters: [
          ['organization.id', '==', orgId],
          ['type', '==', 'field-user']
        ]
      })
      if (okField) {
        const sortedFieldUsers = dataField
          .map(u => ({ id: u.id, name: u.name }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setFieldUsers(sortedFieldUsers)
      }
      
      // Fetch Reviewers
      const {ok: okReviewer, data: dataReviewer} = await usersDB.get(null, {
        filters: [
          ['organization.id', '==', orgId],
          ['type', '==', 'quality-manager']
        ]
      })
      if (okReviewer) {
        const sortedReviewers = dataReviewer
          .map(u => ({ id: u.id, name: u.name }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setReviewers(sortedReviewers)
      }

      // Fetch Installers
      const {ok: okInstaller, data: dataInstaller} = await usersDB.get(null, {
        filters: [
          ['organization.id', '==', orgId],
          ['type', '==', 'installer']
        ]
      })
      if (okInstaller) {
        const sortedInstallers = dataInstaller
          .map(u => ({ id: u.id, name: u.name }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setInstallers(sortedInstallers)
      }
    }
    fetchUsers()
  }, [])

  useEffect(function () {
    (async function () {
      if (!state.dropdown.form) return
      const {ok, data} = await analytics.get(null, {filters: [[`form_id`, `==`, state.dropdown.form]]})
      if (ok) {
        const rubrics = {}
        for (let resource of data) {rubrics[resource.id] = resource}
        dispatch({type: `rubrics`, value: rubrics})
      }
    })()
  }, [state.dropdown.form])

  useEffect(function () {
    if (state.dropdown.rubric) {
      const aggregations = state.rubrics[state.dropdown.rubric].aggregation_types
      dispatch({type: `aggregations`, value: aggregations})
    }
  }, [state.dropdown.rubric])  
  useEffect(function () {
    (async function () {
      if (!state.dropdown.rubric) return

      // Determine which aggregation_type to use
      const aggType = state.dropdown.aggregation === 'reviewer' ? 'reviewer' : 'field_user';
      console.log('Fetching chart_data for rubric:', state.dropdown.rubric, 'aggregation type:', aggType);
      const aggregations = new DB.Aggregations()
      const {ok, data} = await aggregations.get(
        null,
        {filters : [
          [`rubric`, `==`, state.dropdown.rubric],
          [`aggregation_type`, `==`, aggType]
        ]}
      )

      if (ok && data && data.length > 0) {
        let aggregation = data[0];
        console.log('Raw aggregation data:', aggregation);
        
        // Check if we have questions data
        if (!aggregation.questions || aggregation.questions.length === 0) {
          console.warn('No questions found for', aggType, 'aggregation type for rubric:', state.dropdown.rubric);
          dispatch({type: `chart_data`, value: null})
          return;
        }
        
        // Filter questions for selected field user or reviewer if not "All" and not "select"
        const selectedUser = aggType === 'reviewer' ? state.dropdown.reviewer : state.dropdown.fieldUser;

        if (selectedUser && selectedUser !== 'All' && selectedUser !== 'select') {
          console.log('Filtering for user:', selectedUser, 'in aggregation type:', aggType);
          aggregation = {
            ...aggregation,
            questions: aggregation.questions
                .map((question) => {
                  const userResult = (question.results || []).find(
                    (result) => result[aggType] === selectedUser
                  );
                  if (userResult) {
                    return {
                      ...question,
                      num_fail: userResult.num_fail,
                      failed: userResult.num_fail,
                      results: [userResult],
                    };
                  } else {
                    return null;
                  }
                })
                .filter(Boolean)
          };
        }

        console.log('Final chart_data:', aggregation);
        dispatch({type: `chart_data`, value: aggregation});
      } else {
        console.error('No aggregation data found for rubric:', state.dropdown.rubric, 'aggregation type:', aggType);
        dispatch({type: `chart_data`, value: null});
      }
    })();
  }, [state.dropdown.rubric, state.dropdown.fieldUser, state.dropdown.reviewer, state.dropdown.aggregation]);
  
  useEffect(function () {
    (async function () {
      if (!state.dropdown.rubric || !state.dropdown.aggregation) return
      
      const aggType = state.dropdown.aggregation;
      
      const aggregations = new DB.Aggregations()
      const {ok, data} = await aggregations.get(
        null,
        {filters : [[`rubric`, `==`, state.dropdown.rubric], [`aggregation_type`, `==`, aggType]]}
      )
      
      if (ok && data && data.length > 0) {
        let aggregation = data[0];
        console.log('SO_data before filtering:', aggregation);
        
        // Apply filtering logic based on selected user type
        let selectedUser;
        if (aggType === 'reviewer') {
          selectedUser = state.dropdown.reviewer;
        } else if (aggType === 'installer') {
          selectedUser = state.dropdown.installerUser;
        } else { // field_user
          selectedUser = state.dropdown.fieldUser;
        }

        if (selectedUser && selectedUser !== 'All' && selectedUser !== 'select') {
          console.log('Filtering SO_data for user:', selectedUser, 'in aggregation type:', aggType);
          aggregation = {
            ...aggregation,
            questions: aggregation.questions
              .map((question) => {
                const userResult = (question.results || []).find(
                  (result) => result[aggType] === selectedUser
                );
                if (userResult) {
                  return {
                    ...question,
                    results: [userResult], // Keep only the specific user's result
                  };
                } else {
                  return null;
                }
              })
              .filter(Boolean),
          };
        }
        
        console.log('Dispatching SO_data and data:', aggregation);
        dispatch({type: `data`, value: aggregation})
        dispatch({type: `SO_data`, value: aggregation})
      } else {
        console.warn('No SO_data found for:', state.dropdown.rubric, aggType);
        dispatch({type: `data`, value: null})
        dispatch({type: `SO_data`, value: null})
      }
    })()        
  }, [state.dropdown.rubric, state.dropdown.aggregation, state.dropdown.fieldUser, state.dropdown.reviewer, state.dropdown.installerUser])

  function setDropdown(type, value) {
    if (state.dropdown[type] === value) return
    dispatch({ type, value })
  }

  // Helper: set aggregator type and value based on dropdown selection
  function handleAggregatorChange(type, value) {
    console.log('handleAggregatorChange:', type, value);
    
    if (type === 'fieldUser') {
      dispatch({ type: 'aggregation', value: 'field_user' });
      dispatch({ type: 'fieldUser', value });
      dispatch({ type: 'reviewer', value: 'select' });
      dispatch({ type: 'installerUser', value: 'select' });
    } else if (type === 'reviewer') {
      dispatch({ type: 'aggregation', value: 'reviewer' });
      dispatch({ type: 'reviewer', value });
      dispatch({ type: 'fieldUser', value: 'select' });
      dispatch({ type: 'installerUser', value: 'select' });
    } else { // installerUser
      dispatch({ type: 'aggregation', value: 'installer' });
      dispatch({ type: 'installerUser', value });
      dispatch({ type: 'fieldUser', value: 'select' });
      dispatch({ type: 'reviewer', value: 'select' });
    }
  }

  // On mount, set default to field_user aggregation
  useEffect(() => {
    if (!state.dropdown.aggregation) {
      dispatch({ type: 'aggregation', value: 'field_user' });
    }
    if (!state.dropdown.fieldUser) {
      dispatch({ type: 'fieldUser', value: 'select' });
    }
    if (!state.dropdown.reviewer) {
      dispatch({ type: 'reviewer', value: 'select' });
    }
    if (!state.dropdown.installerUser) {
      dispatch({ type: 'installerUser', value: 'select' });
    }
  }, [dispatch, state.dropdown.aggregation, state.dropdown.fieldUser, state.dropdown.reviewer, state.dropdown.installerUser]);

  // After rubric is selected, set field user to All if all dropdowns are still on select
  useEffect(() => {
    console.log('Rubric effect triggered:', {
      rubric: state.dropdown.rubric,
      fieldUser: state.dropdown.fieldUser,
      reviewer: state.dropdown.reviewer,
      installerUser: state.dropdown.installerUser
    });
    
    if (state.dropdown.rubric && 
        state.dropdown.fieldUser === 'select' && 
        state.dropdown.reviewer === 'select' &&
        state.dropdown.installerUser === 'select') {
      console.log('Setting defaults after rubric selection');
      dispatch({ type: 'fieldUser', value: 'All' });
    }
  }, [state.dropdown.rubric]);

  // Add debugging for state changes
  useEffect(() => {
    console.log('Dropdown state changed:', {
      fieldUser: state.dropdown.fieldUser,
      reviewer: state.dropdown.reviewer,
      installerUser: state.dropdown.installerUser,
      aggregation: state.dropdown.aggregation
    });
  }, [state.dropdown.fieldUser, state.dropdown.reviewer, state.dropdown.installerUser, state.dropdown.aggregation]);

  // Prepare dropdown options
  const fieldUserOptions = [
    { id: 'select', name: 'Select Field User' },
    { id: 'All', name: 'All Field Users' },
    ...fieldUsers
  ];
  const reviewerOptions = [
    { id: 'select', name: 'Select Reviewer' },
    { id: 'All', name: 'All Reviewers' },
    ...reviewers
  ];
  const installerOptions = [
    { id: 'select', name: 'Select Installer' },
    { id: 'All', name: 'All Installers' },
    ...installers
  ];

  return (
    <div>
      <div className="flex-row selectors" >
        <div style={{flex: 1}} >
          <GenericSelector
            className="first"
            placeholder="Select Form"
            values={state.forms}
            valueTitle="title"
            selectedValue={state.dropdown.form}
            onChange={value => setDropdown(`form`, value)}
          />
        </div>
        <div style={{flex: 1}} >
          <GenericSelector
            placeholder={state.rubrics ? `Select Rubric` : `Select Rubric`}
            values={Object.values(state.rubrics || {}).sort()}
            valueTitle="rubric_name"
            selectedValue={state.dropdown.rubric}
            onChange={value => setDropdown(`rubric`, value)}
          />
        </div>
        <div style={{flex: 1}} >
          <GenericSelector
            placeholder="Select Field User"
            values={fieldUserOptions}
            valueTitle="name"
            selectedValue={state.dropdown.fieldUser || 'select'}
            onChange={value => handleAggregatorChange('fieldUser', value)}
          />
        </div>
        <div style={{flex: 1}} >
          <GenericSelector
            placeholder="Select Reviewer"
            values={reviewerOptions}
            valueTitle="name"
            selectedValue={state.dropdown.reviewer || 'select'}
            onChange={value => handleAggregatorChange('reviewer', value)}
          />
        </div>
        <div style={{flex: 1}} >
          <GenericSelector
            placeholder="Select Installer"
            values={installerOptions}
            valueTitle="name"
            selectedValue={state.dropdown.installerUser || 'select'}
            onChange={value => handleAggregatorChange('installerUser', value)}
          />
        </div>
      </div>
      {/* Label below dropdowns, right aligned, only after rubric is selected */}
      {state.dropdown.rubric && (
        <div style={{width: '100%', marginTop: 8, marginBottom: 8, textAlign: 'right'}}>
          <span style={{fontWeight: 500}}>
            Viewing data as: <span style={{color: '#1890ff'}}>
              {state.dropdown.fieldUser === 'All'
                ? 'Field User for All'
                : state.dropdown.fieldUser !== 'select' && state.dropdown.fieldUser !== 'All'
                  ? 'Field User'
                  : state.dropdown.reviewer === 'All'
                    ? 'Reviewer for All'
                    : state.dropdown.reviewer !== 'select' && state.dropdown.reviewer !== 'All'
                      ? 'Reviewer'
                      : state.dropdown.installerUser === 'All'
                        ? 'Installer for All'
                        : state.dropdown.installerUser !== 'select' && state.dropdown.installerUser !== 'All'
                          ? 'Installer'
                          : 'Field User for All'}
            </span>
            {` `}
            {state.dropdown.fieldUser !== 'select' && state.dropdown.fieldUser !== 'All'
              ? `for "${fieldUsers.find(u => u.id === state.dropdown.fieldUser)?.name || ''}"`
              : state.dropdown.reviewer !== 'select' && state.dropdown.reviewer !== 'All'
                ? `for "${reviewers.find(u => u.id === state.dropdown.reviewer)?.name || ''}"`
                : state.dropdown.installerUser !== 'select' && state.dropdown.installerUser !== 'All'
                  ? `for "${installers.find(u => u.id === state.dropdown.installerUser)?.name || ''}"`
                  : ''}
          </span>
        </div>
      )}
    </div>
  )
}